<template>
    <div>
        <div class="row card-body p-4">
            <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3" style="margin: 0 auto;">
                <div v-if="showEsignature && !hasBeenSignedWithUAEPass" class="col select-Signature-Box">
                    <div class="card shadow-sm" :disabled="!validForm" @click="signDocument">
                        <img src="/assets/images/icons/esignature.png" style="margin: 0 auto;margin-top: 30px" alt="UAEPASS"
                            width="63%" height="63%" />
                        <div class="card-body" style="text-align: center;">
                            <p class="card-text">{{ $t("res_Label_E-Signature") }}
                            </p>
                        </div>
                    </div>
                </div>
                <div v-if="signUsingUAEPassEnabled" class="col select-Signature-Box">
                    <div class="card shadow-sm" @click="signDocumentWithUaePass">
                        <img src="/assets/images/icons/uaepass.png" style="margin: 0 auto;margin-top: 30px;" alt="UAEPASS"
                            width="60%" height="60%" />
                        <div class="card-body" style="text-align: center;">
                            <p class="card-text">UAE-PASS</p>
                        </div>
                    </div>
                </div>
                <div v-if="signUsingDocusignEnabled">
                    <div class="col select-Signature-Box">
                        <div class="card shadow-sm" @click="signDocumentWithDocusign">
                            <img src="/assets/images/icons/docusign.svg" style="margin: 0 auto;margin-top: 30px;" alt="UAEPASS"
                                width="60%" height="60%" />
                            <div class="card-body" style="text-align: center;">
                                <p class="card-text">Docusign</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="padding-top: 15px;">
            <v-card-actions class="gap-2 sticky-actions">
                <v-spacer></v-spacer>
                <v-btn class="light-blue" style="min-width: 100px !important;" @click="cancelDialog">{{ $t("res_ButtonText_Cancel") }}</v-btn>
            </v-card-actions>
        </div>
    </div>
</template>

<script>
import constants from '@/assets/js/constants'
import axios from 'axios'

export default {
    name: 'Sign',
    data() {
        return {
            pinValue: '',
            validForm: false,
            showEsignature: true,
            signUsingUAEPassEnabled: true,
            signUsingDocusignEnabled: true,
            uaeImageUrl:"",
            lang:""
        };
    },
    props: 
    {
        dialogModelShow: { type: Boolean, default: false },
        propertyBag: { type: Object },
        isSignAndSend: {type: Boolean, default: false},
        hasBeenSignedWithUAEPass: { type: Boolean, default: false },
        isUAEPassEnabledForTemplate: { type: Boolean, default: false },
        isEsealEnabledForTemplate: { type: Boolean, default: false },
    },
    methods:
    {
        getPermissionToSignWithUAEPass()
        {
            axios.get("")
            .then(res=>
                {
                    if(res){console.log('isenabled = ',res.data)
                        if(res.data){
                            this.signUsingUAEPassEnabled = true;
                        }
                        else{
                            this.signUsingUAEPassEnabled = false
                        }
                    }
                }
            )
        },
        getPermissionToSign() 
        { 
            window.showLoading()
            axios.get(constants.baseApiUrl + 'Document/CheckHasValidSignature?delegationId=' + this.propertyBag.delegationId)
                .then(res => 
                {
                    if (res.data == 'SignaturePinNotSet')
                        window.showAlert('You have not set a signature pin. Please set a signature pin in your profile', 'warning')

                    else if (res.data == 'NoDefaultSignatureFound')
                        window.showAlert('You don\'t have a default signature. Please add a signature and set it to default', 'warning')

                    else
                        this.validForm = true
                })
                .catch(err => window.showAlert(err, 'error'))
                .finally(() => window.hideLoading())

            if (sessionStorage.getItem('sign_using_UAEPass') != null){
                var sign_using_UAEPASSConstant = (sessionStorage.getItem('sign_using_UAEPass') === "true")
                if(this.isUAEPassEnabledForTemplate != null && sign_using_UAEPASSConstant)
                this.signUsingUAEPassEnabled = this.isUAEPassEnabledForTemplate
                //this.getPermissionToSignWithUAEPass()
                
            }
                
                //this.signUsingUAEPassEnabled = (sessionStorage.getItem('sign_using_UAEPass') === "true")

            if (sessionStorage.getItem('sign_using_Docusign') != null)
                this.signUsingDocusignEnabled = (sessionStorage.getItem('sign_using_Docusign') === "true")
        },
        signDocument() 
        {
            this.$emit('closeSignMethodSelectAndOpenSignWithPin')
        },
        async signDocumentWithUaePass() 
        {
            if(this.isUAEPassEnabledForTemplate){
                window.showLoading();
	        let baseUrl = constants.baseApiUrl;
                axios.get(baseUrl + 'Document/CheckHasValidSignature?delegationId=' + this.propertyBag.delegationId)
                    .then(res => 
                    {
                        if (res.data == 'SignaturePinNotSet')
                            window.showAlert('You have not set a signature pin. Please set a signature pin in your profile', 'warning')

                        else if (res.data == 'NoDefaultSignatureFound')
                            window.showAlert('You don\'t have a default signature. Please add a signature and set it to default', 'warning')

                        else
                            {
            axios.post(baseUrl + 'Document/SignUAEPassDocuments?documentId=' + this.propertyBag.documentId + '&transferId=' + this.propertyBag.transferId + '&delegationId=' + this.propertyBag.delegationId)
                .then(async res => 
                {
                    console.log('uae res  = ',res)
                    let token = sessionStorage.getItem('jwt_token');
                    let documentId = this.propertyBag.documentId;
                    var w = 720;
                    var h = 530;
                    var title = 'UAEPASAUTH'
                    var left = (screen.width / 2) - (w / 2);
                    var top = (screen.height / 2) - (h / 2);

                    const payload = {
                        id: documentId,
                        x: res.data.item1.x,
                        y: res.data.item1.y,
                        stampX: res.data.item2.x,
                        stampY: res.data.item2.y,
                        ltvEnabled: constants.ltvEnabled,
                        esealEnabled: constants.esealEnabled,
                        lang: this.lang,
                        token: token,
                        userId: 0,
                        structureId: 0,
                    }

                    const response = await axios.post(baseUrl + 'UAEPassForWeb', payload)

                    const redirectUrl = response.data.redirectUrl

                    if (redirectUrl) {
                    var windowObjectReference = window.open(redirectUrl, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
                    if (!windowObjectReference || windowObjectReference.closed || typeof windowObjectReference.closed == 'undefined') {
                        alert('Popup blocked! Please allow popups for this website.');
                    }
                    } else {
                        console.error('No redirect URL found in the response.');
                    }

                    // const url = baseUrl + 'UAEPass?id=' + documentId + 
                    // '&x=' + res.data.item1.x + '&y=' + res.data.item1.y + 
                    // '&stampX=' + res.data.item2.x + '&stampY=' + res.data.item2.y +
                    // '&ltvEnabled=' + constants.ltvEnabled + 
                    // '&esealEnabled=' + constants.esealEnabled +
                    // "&lang=" + this.lang + 
                    // '&token=' + token;
                    // console.log(url); // Check the URL
                    // var windowObjectReference =  window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

                    //var windowObjectReference =window.open(url, title, 'width=' + w + ', height=' + h);

               

                      const checkStatus = () => 
                    {
                        this.checkUAEPassSignStatus(interval, windowObjectReference, baseUrl);
                    }

                    const interval = setInterval(() =>
                    {
                        checkStatus();
                    }, 2000);
                })
                .catch(error => console.log(error))
                            }
                    })
                    .catch(err => window.showAlert(err, 'error'))
            }
            else{
                window.showAlert(this.$t('res_Msgs_UAEPASSNotEnabledForTemplage'), 'warning')
            }
        },
        signDocumentWithDocusign() 
        {
            window.showLoading();
            let baseUrl = constants.baseApiUrl;
            axios.post(baseUrl + 'Document/PrepareDocumentForDocuSign?documentId=' + this.propertyBag.documentId + '&transferId=' + this.propertyBag.transferId + '&delegationId=' + this.propertyBag.delegationId)
                .then(res => 
                {
                    let token = sessionStorage.getItem('jwt_token');
                    var windowObjectReference = window.open(res.data.item2,"Sign With Docusign",'_blank');
                    var envelopeId=res.data.item1;
                    window.hideLoading();
                    console.log('data', res)
                })
                .catch(error => console.log(error))
        },
        checkUAEPassSignStatus(interval, popup, baseUrl)
        {
            if (popup.closed == true) 
            {
                window.hideLoading()
            }
            else 
            {
                let token = sessionStorage.getItem('jwt_token');
                let documentId = this.propertyBag.documentId;

                var payload = {
                    DocumentId: documentId,
                    Token: token
                }

                axios.post(baseUrl + 'UAEPassForWeb/SigningStatus', payload)
                    .then(res => 
                    {
                   
                        if (res.data == "" || res.data == undefined || res.data == null)
                            return;
          
                        if (res.data == "finished") 
                        {
                            // window.showAlert('Successfully Signed', 'success')
                            axios.post(baseUrl + 'Document/MarkDocumentSigned?documentId=' + this.propertyBag.documentId + '&transferId=' + this.propertyBag.transferId + '&delegationId=' + this.propertyBag.delegationId)
                                .then(res => 
                                {
                                  
                                    // setTimeout(async ()=> {
                                    //     if(constants.ltvEnabled){
                                    //         await this.$emit('refreshAfterClosingSignMethodSelect')
                                    //         this.lTVDocument()
                                    //     }
                                    //     else if(constants.esealEnabled){
                                    //         await this.$emit('refreshAfterClosingSignMethodSelect')
                                    //         this.eSealDocument()
                                    //     }
                                    //     else{
                                    window.hideLoading();
                                            window.showAlert(this.$t('res_Msgs_SignedSuccess'), 'success')
                                          //  this.$emit('refreshAfterClosingSignMethodSelect')
                                    console.log('uae cleared = ',res)
                                            console.log("issigneandsend = ",this.isSignAndSend)
                                            if(this.isSignAndSend){
                                                window.showLoading()
                                                this.$emit('uaeDocumentSigned')
                                            }
                                            else{
                                                this.$emit('refreshAfterClosingSignMethodSelect')
                                            }
                                    //     }
                                    
                                    // }, 2000);
                                    
                                })
                        }
                        else if(res.data=="canceled")                      
                        {   
                             clearInterval(interval);
                             popup.close();
                             this.$emit('refreshAfterClosingSignMethodSelect')
                            window.hideLoading();
                            // update table again 
                             window.showUaepassAlert(this.$t('res_Msgs_UAEPASS_Canceled'), 'warning')
                            this.UpdateUaePassStatus(baseUrl,documentId,token)
                            this.cancelDialog()
                           
                        }
                         else if(res.data=="failed")
                         {   
                             clearInterval(interval);
                             popup.close();
                             this.$emit('refreshAfterClosingSignMethodSelect')
                            window.hideLoading();
                            // update table again 
                             window.showUaepassAlert(this.$t('res_Msgs_UAEPASS_SOP2DigitalSignatureRestriction'), 'warning')
                            this.UpdateUaePassStatus(baseUrl,documentId,token)
                            this.cancelDialog()
                           
                        }
                        else 
                        {   
                         
                            window.showAlert('Something went wrong', 'warning')
                            this.$emit('refreshAfterClosingSignMethodSelect')
                            window.hideLoading();
                        }
                        clearInterval(interval);
                        popup.close();
                        
                     //   this.$emit('refreshAfterClosingSignMethodSelect');
                    })
                    .catch(err => window.showAlert(err, 'error'))
            }
        },

		UpdateUaePassStatus(baseUrl,documentId,token){debugger; console.log("UpdateUaePassStatus");
        var payload = {
            DocumentId: documentId,
            Token: token
        }
    axios.post(baseUrl + 'UAEPassForWeb/UpdateSigningStatus', payload)
                    .then(res => 
                    {console.log(res);

                    })}
,
        eSealDocument(){
            let baseUrl = constants.baseApiUrl;
            let documentId = this.propertyBag.documentId;
            axios.get(baseUrl + 'UAEPassForWeb/ESealDocument?documentId=' + documentId )
                    .then(res => 
                    {
                        console.log("eseal = ",res)
                        window.hideLoading();
                        window.showAlert(this.$t('res_Msgs_SignedSuccess'), 'success')
                        this.$emit('refreshAfterClosingSignMethodSelect')
                    })  
        },
        lTVDocument(){
            let baseUrl = constants.baseApiUrl;
            let documentId = this.propertyBag.documentId;
            axios.get(baseUrl + 'UAEPassForWeb/LTVDocument?documentId=' + documentId )
            .then(async res => 
            {
                console.log("eseal = ",res)
                if(constants.esealEnabled){
                    await this.$emit('refreshAfterClosingSignMethodSelect')
                    setTimeout(async ()=> {
                    this.eSealDocument(),2000})
                }
                else{
                    window.hideLoading();
                    window.showAlert(this.$t('res_Msgs_SignedSuccess'), 'success')
                    this.$emit('refreshAfterClosingSignMethodSelect')
                }
                
            })  
},
        cancelDialog() 
        {
            this.$emit('closeSelectSignMethodFormDialog');
        },
        resetForm() 
        {
            this.pinValue = ''
            this.validForm = false
        },
        checkDocusignEnvolvement()
        {
            let baseUrl = constants.baseApiUrl;
            axios.post(baseUrl + 'Document/CheckIfSignedFromExternalSystem?documentId=' + this.propertyBag.documentId )
                .then(res => 
                {
                    if (res.data)
                        this.showEsignature = false;
                })
                .catch(error => console.log(error))
        }
    },
    watch:
    {
        dialogModelShow(newVal, oldVal) 
        {
            if (newVal != oldVal) 
            {
                if (newVal == true)
                    this.getPermissionToSign()
                else
                    this.resetForm()
            }
        }
    },
    mounted: function () 
    {
        this.getPermissionToSign()
        this.checkDocusignEnvolvement()
        this.lang = 'en'
        if (localStorage.getItem('lang') != null){

            this.lang = localStorage.getItem('lang')
        }
        if(this.lang=="en"){
            this.uaeImageUrl = "/assets/images/UAEPASS_Sign_with_Btn_Outline_Default_Active_English.png";
        }
        else{
            this.uaeImageUrl = "/assets/images/UAEPASS_Sign_in_Btn_Outline_Default_Active_Arabic.png";
        }
    }
}
</script>